import { api } from '@services';

import { IEquipmentApiModel } from '@models/Equipment.model';
import { Result } from '@utils/index';
import {
  toUniqueFieldsErr,
  UpdateContentError,
} from '@services/queries/customField/updateCustomFieldContent/updateCustomFieldContent';
import { AxiosResponse } from 'axios';

type CustomFieldSend = {
  id: string;
  content: any;
};

export interface INewEquipment {
  productId?: string;
  equipmentStatusId?: string;
  purchasedPrice?: number | null;
  purchasedFrom?: string | null;
  serial?: string | null;
  sla?: string | null;
  purchasedDate?: Date | null;
  licenseStartDate?: Date | null;
  licenseEndDate?: Date | null;
  userId?: string | null;
  vendor?: string | null;
  installDate?: Date | null;
  installedSoftwareVersion?: string | null;
  installedFirmwareVersion?: string | null;
  extendedWarrantyPurchased?: boolean | null;
  extendedWarrantyLength?: number | null;
  statusComment?: string | null;
  customFields?: CustomFieldSend[];
  tagsId?: string[];
  importedName?: string | null;
  importedModel?: string | null;
  importedManufacturerName?: string | null;
}
interface IPatchEquipmentVariables {
  id: string;
  data: INewEquipment;
}
type IResponse = AxiosResponse<IEquipmentApiModel>;
const patchEquipment = async ({
  id,
  data,
}: IPatchEquipmentVariables): Promise<IEquipmentApiModel> => {
  const axiosResponse = api.patch<IEquipmentApiModel>(
    `/equipments/${id}`,
    data,
  );
  const result = await Result.asyncCatch<UpdateContentError, IResponse>(
    axiosResponse,
  );

  const result_map = Result.mapErr(result, toUniqueFieldsErr);
  if (result_map.is_ok) {
    const { data: equipment } = result_map.data;
    return equipment;
  }
  throw result_map.error;
};

export { patchEquipment };
